/**
 * Checks if a hostname matches a domain exactly or as a subdomain
 * @param hostname - The hostname to check (e.g., "www.catinaflat.com")
 * @param domain - The domain to match against (e.g., "catinaflat.com")
 * @returns True if hostname matches the domain exactly or is a subdomain of it
 */
export const matchesDomain = (hostname: string, domain: string): boolean => {
  const lowercaseHostname = hostname.toLowerCase();
  const lowercaseDomain = domain.toLowerCase();
  return lowercaseHostname === lowercaseDomain || lowercaseHostname.endsWith(`.${lowercaseDomain}`);
};

/**
 * Checks if a hostname matches any domain in a list
 * @param hostname - The hostname to check
 * @param domains - Array of domains to check against
 * @returns True if hostname matches any domain in the list
 */
export const matchesAnyDomain = (hostname: string, domains: string[]): boolean => {
  return domains.some((domain) => matchesDomain(hostname, domain));
};
